<div class="desktop-width-limiter detail-page page-padding" [class.d-none]="isServer">
  @if (!loading && !error && event) {
  <div class="detail-page-content">
    <div class="page-content">
      <div class="video-player-container">
        <div class="video-player">
          <div class="media-and-buttons">
            @if (event.mediaItems.length > 1 && selectedItemIndex != 0) {
            <button class="arrow left" (click)="navigate(-1)">&#8249;</button>
            } @if ( selectedMediaItem && selectedMediaItem.mediaType ==
            MediaType.Video && !selectedMediaItem.url ) {
            <video-player [id]="'vid1'" [src]="" [autoplay]="false" [width]="'100%'"
              [height]="isMobile ? '250px' : '400px'">
              {{ selectedMediaItem | json }}
            </video-player>
            }
            <!-- Below element is inserted twice so make sure change detection properly triggers when switching from video -->
            @if ( selectedMediaItem && selectedMediaItem.mediaType ==
            MediaType.Video && selectedMediaItem.url && selectedItem === 0 ) {
            <video-player [id]="'vid1'" [videoId]="selectedMediaItem.partitionKey.replace('.', '_')"
              [src]="selectedMediaItem.url" [autoplay]="false" [width]="'100%'" [height]="isMobile ? '250px' : '400px'"
              [poster]="getThumbnailUrl(selectedMediaItem.thumbnail)" [isHighImpactEvent]="event.isHighImpactEvent"
              [rawInput]="selectedMediaItem.url.indexOf('manifest') === -1">
              {{ selectedMediaItem | json }}
            </video-player>
            } @if ( selectedMediaItem && selectedMediaItem.mediaType ==
            MediaType.Video && selectedMediaItem.url && selectedItem === 1 ) {
            <video-player [id]="'vid1'" [videoId]="selectedMediaItem.partitionKey.replace('.', '_')"
              [src]="selectedMediaItem.url" [autoplay]="false" [width]="'100%'" [height]="isMobile ? '250px' : '400px'"
              [poster]="getThumbnailUrl(selectedMediaItem.thumbnail)" [isHighImpactEvent]="event.isHighImpactEvent"
              [rawInput]="selectedMediaItem.url.indexOf('manifest') === -1">
              {{ selectedMediaItem | json }}
            </video-player>
            }
            <!-- Video still processing error text -->
            @if (!selectedMediaItem.url) {
            <div class="processing-container">
              <span class="processing-text">{{
                "page.detail.processing" | translate
                }}</span>
            </div>
            } @if ( selectedMediaItem && selectedMediaItem.mediaType ==
            MediaType.Image ) {
            <img class="media-image" [src]="selectedMediaItem.url"
              onerror="this.onerror = null; this.src = './assets/images/fallback-thumb.png';" />
            } @if (event.mediaItems.length > 1 && selectedItemIndex !=
            (event.mediaItems.length-1)) {
            <button class="arrow right" (click)="navigate(1)">&#8250;</button>
            }
          </div>
        </div>
        <div class="header">
          <div class="title-and-category">
            <h1 class="pageTitle" [title]="event.title">
              {{ event.title }}
            </h1>
            @if (event.category && event.subcategory) {
            <div class="category-chips">
              <div class="chip" [title]="event.category">
                {{ event.category }}
              </div>
              <div class="chip" [title]="event.subcategory">
                {{ event.subcategory }}
              </div>
            </div>
            }
          </div>

          <div class="buttons">
            @if (isMyStreApp) {
            <edit-content-button [eventId]="event.partitionKey">
            </edit-content-button>
            }
            @if (isMyStreApp) {
            <delete-streapp-button [eventId]="event.partitionKey" [eventTitle]="event.title"></delete-streapp-button>
            }
            @if (isLoggedIn() && !isMyStreApp) {
            <reporting-button [eventId]="event.partitionKey" [buttonTitle]="'report.report_event'">
            </reporting-button>
            }
            @if (!isMyStreApp) {
            <buy-media [StreAppEvent]="event" [SelectedMediaItem]="selectedMediaItem">
            </buy-media>
            }

            <share-button [event]="event" [isMyStreApp]="isMyStreApp"
              [selectedMediaItem]="selectedMediaItem"></share-button>
          </div>
        </div>
        <div class="profile">
          <page-attributes [event]="event" [streapper]="streapper"></page-attributes>
        </div>
        <div class="description" [title]="'general.description' | translate">
          <p #description class="container" [class.show]="show">
            {{ event.description }}
          </p>
          @if (checkOverflow(description)) {
          <button matRipple (click)="show = !show">
            {{ "page.detail.buttons.read_more" | translate }}
          </button>
          } @if (show) {
          <button matRipple (click)="show = !show">
            {{ "page.detail.buttons.read_less" | translate }}
          </button>
          }
        </div>
        @if (event.mediaItems.length > 1) {
        <image-carousel [mediaItemArray]="event.mediaItems" [selectedMediaItem]="selectedMediaItem"
          (mediaItemClicked)="selectMediaItem($event)">
        </image-carousel>
        }
      </div>
      @if (event.linkedStreappEvents?.length > 0 ||
      (event.linkedStreappEvents?.length === 0 && showLinkedEvents)) {
      <div class="linked-events">
        <!-- Hier komen gekoppelde streapps, of relevante streapps -->
        @if (event.linkedStreappEvents?.length > 0) {
        <linked-events [event]="event"></linked-events>
        } @if (event.linkedStreappEvents?.length === 0) {
        <related-events [event]="event" (getShowRelatedEvents)="updateShowLinkedEvents($event)"></related-events>
        }
      </div>
      }
    </div>
    <div class="side-container">
      <reaction [items]="reactions" (addReaction)="addReaction($event)" (removeReaction)="removeReaction($event)"
        (updateReaction)="updateReaction($event)" [eventId]="event.partitionKey">
      </reaction>

      @if(displayAds) {
      <div class="ads-vertical">
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-1807328328271021"
          data-ad-slot="7063841727" data-ad-format="vertical" data-full-width-responsive="true">
        </ins>
      </div>
      }
    </div>
  </div>
  @if (hasScrolled) {
  <scroll-up></scroll-up>
  } } @if (loading) {
  <div class="loading">
    <mat-progress-spinner class="loading-spinner" [diameter]="75" mode="indeterminate" color="primary">
    </mat-progress-spinner>
  </div>
  } @if (!loading && error) {
  <div class="errorText">
    {{ "page.error" | translate }}
  </div>
  }
</div>